// extracted by css-extract-rspack-plugin
export default {"panel":"FiZIm"};